export default __webpack_public_path__ + "static/media/phoneMessage.e242390e.png";